export const __DEV__ = import.meta.env.MODE !== "production";
export const __STAGING__ = import.meta.env.VITE_IS_NEXT === "true" || __DEV__;
export const __SOFTDB_ID__ = import.meta.env.VITE_SOFTDB_ID || "2";
